import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  ActivitiesServiceProxy,
  ActivityDayListDto,
  ActivityDaysServiceProxy,
  AllocationSheetsServiceProxy,
  AllocationSheetStatus,
  CopyNameToAllActivityDaysInput,
  GetActivityDayListtDto,
  UpdateActivityNameInput,
} from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-activities-assign-panel',
  templateUrl: './activities-assign-panel.component.html',
  styleUrls: ['./activities-assign-panel.component.less'],
})
export class ActivitiesAssignPanelComponent
  extends AppComponentBase
  implements OnInit {
  @Input() context: 'allocation' | null;
  @Input() activityData: any;
  @Input() allowedPersonnel: any;
  @Input() allowedPlants: any;
  @Input() variancesFromPlanReasons: any;
  @Input() assetsToBeAssigned: any;
  @Input() cloneModal: any;
  @Input() allowedMaterials: any;
  
  @Output() onClosePanel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onListReload: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAssignPanelOpen: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFiltersChange: EventEmitter<any> = new EventEmitter<any>();
  public creatorFilterFormCtrl: FormControl = new FormControl();
  public creatorFormCtrl: FormControl = new FormControl();
  public getActivityDayListtDto :  GetActivityDayListtDto=new GetActivityDayListtDto();
  activityNameEdit = false;
  activityNameHasChanged = false;

  controllingStructureCode : any;
  variancelCode : any;

  personnelTotal = 0;
  plantsTotal = 0;
  materialsTotal=0;

  IsDisable = false;
  activityList: ActivityDayListDto[];
  selectedforCopyActivityId:ActivityDayListDto;
  allocationSheetStatusNotSubmitted = AllocationSheetStatus.NotSubmitted;
  allocationSheetStatus = 0;
  allocationSheetId;
  constructor(
    injector: Injector,
    private _activitiesServiceProxy: ActivitiesServiceProxy,
    private _activityDaysServiceProxy: ActivityDaysServiceProxy,
    private cdr: ChangeDetectorRef,
    private _projectService : ProjectService,
    private _activatedRoute: ActivatedRoute,
    private _allocationSheetsServiceProxy: AllocationSheetsServiceProxy
  ) {
    super(injector);
  }

  afterClone() {}

  ngOnInit(): void {
    setTimeout(() => {
      this.cdr.detectChanges();
      //For copy Activity feature. it will be enabled in future
      //this.getActivityList();
    }, 50);
    this.allocationSheetId = this._activatedRoute.snapshot.params.id;
    this.getAllocationSheetStatus();
  }

  async getActivityList(){
    this._activityDaysServiceProxy
    .getMyActivityDayList()
    .subscribe((activity) => {
      this.activityList=activity.activityDays;
    });
  }
  closePanel() {
    this.onClosePanel.emit();
  }

  openActivityPanel(event) {
    this.onAssignPanelOpen.emit(event);
  }

  cloneActivity(activityId: string, activityDayId: string,copyWithData: boolean) {
    if (!activityId) return;

    this._activitiesServiceProxy.getWorkDaysForActivity(activityId).subscribe(
      (days) => {
        this.cloneModal.disabledDays = days.map((day) =>
          day.format('yyyy-MM-DD')
        );
        this.cloneModal.activityDayId = activityDayId;
        this.cloneModal.copyWithData=copyWithData;
        this.cloneModal.modal.show();
      },
      () => {
        this.notify.error(this.l('Error occured'));
      }
    );
  }

  deleteDay(activityDayId: string): void {
    this.message.confirm('', this.l('RemoveADConfirmation'), (isConfirmed) => {
      if (isConfirmed) {
        this._activityDaysServiceProxy
          .deleteActivityDay(activityDayId)
          .subscribe(() => {
            this.closePanel();
            this.onListReload.emit();
            this.notify.success(this.l('ActivityHasBeenRemoved'));
          });
      }
    });
  }

  deleteNotSubmittedDays(activityId: string): void {
    this.message.confirm(
      '',
      this.l('RemoveAllADConfirmation'),
      (isConfirmed) => {
        if (isConfirmed) {
          this._activityDaysServiceProxy
            .deleteNotSubmittedActivityDays(activityId)
            .subscribe(() => {
              this.closePanel();
              this.onListReload.emit();
              this.notify.success(this.l('ActivityHasBeenRemoved'));
            });
        }
      }
    );
  }

  setActivityNameEdit() {
    if (!this.activityNameEdit) {
      setTimeout(() => {
        document.getElementById('activityNameInput').focus();
      }, 150);
    }
    this.activityNameEdit = !this.activityNameEdit;
  }

  updateActivityName(name: string, activityDayId: string) {
    const params = new UpdateActivityNameInput({
      name,
      activityDayId,
    });
    this.activityNameEdit = false;

    this._activityDaysServiceProxy.updateActivityName(params).subscribe(() => {
      this.activityNameHasChanged = true;
      abp.event.trigger('app.evt.activityNameChanged', this.activityData);
    });
  }

  applyAll(activityDayId: string) {
    const params = new CopyNameToAllActivityDaysInput({ activityDayId });
    this._activityDaysServiceProxy.copyNameToAll(params).subscribe(() => {
      this.notify.success(this.l('NameHasBeenCopied'));
    });
  }
  
  updateControllerCounter(eventData: any) {
    this.controllingStructureCode = eventData;

    if(this.controllingStructureCode != null && 
        this.variancelCode != null &&
        (this.personnelTotal > 0 ||
          this.plantsTotal > 0 || 
          this.materialsTotal > 0) )
        {
          this.activityData.isCompleteToBeEnrolled = true;
          this.onListReload.emit();
        }

    this.cdr.detectChanges();
  }
  
  updateVercinnceCounter(eventData: any) {
    this.variancelCode = eventData;
    
    if(this.controllingStructureCode != null && 
        this.variancelCode != null &&
        (this.personnelTotal > 0 ||
          this.plantsTotal > 0 || 
          this.materialsTotal > 0) )
        {
          this.activityData.isCompleteToBeEnrolled = true;
          this.onListReload.emit();
        }

    this.cdr.detectChanges();
  }

  updatePersonnelCounter(eventData: number) {
    this.personnelTotal = eventData;
    
    if(this.controllingStructureCode != null && 
        this.variancelCode != null &&
        (this.personnelTotal > 0 ||
          this.plantsTotal > 0 || 
          this.materialsTotal > 0) )
        {
          this.activityData.isCompleteToBeEnrolled = true;
          this.onListReload.emit();
        }

    this.cdr.detectChanges();
  }

  updatePlantCounter(eventData: number) {
    this.plantsTotal = eventData;
    
    if(this.controllingStructureCode != null && 
        this.variancelCode != null &&
        (this.personnelTotal > 0 ||
          this.plantsTotal > 0 || 
          this.materialsTotal > 0) )
        {
          this.activityData.isCompleteToBeEnrolled = true;
          this.onListReload.emit();
        }

    this.cdr.detectChanges();
  }
  
  updateMaterialCounter(eventData: number) {
    this.materialsTotal = eventData;
    
    if(this.controllingStructureCode != null && 
        this.variancelCode != null &&
        (this.personnelTotal > 0 ||
        this.plantsTotal > 0 || 
        this.materialsTotal > 0))
        {
          this.activityData.isCompleteToBeEnrolled = true;
          this.onListReload.emit();
        }

    this.cdr.detectChanges();
  }

  GetControlDisabledForPlantPersonalAndMatiral(isSubmitted: Boolean): boolean {    
    this.IsDisable = false;

    if(isSubmitted)
    {
      this.IsDisable = true;
    }
    if(!isSubmitted && !this.isGranted('Pages.Activities.Create'))
    {
      this.IsDisable = true;
    }

    if(isSubmitted && this.isGranted('Pages.AllocationSheets.ProjectAdministrator'))
    {
      this.IsDisable = false;
    }
    return this.IsDisable;
  }

  updateSelectedActivity(activityDayListDto:ActivityDayListDto) {
    this.selectedforCopyActivityId=activityDayListDto;
  }

  updateSelectedActivityEnroreded(activityDayListDto:ActivityDayListDto) {
    
    this.selectedforCopyActivityId=activityDayListDto;
  }
  
  getAllocationSheetStatus(){
    if(this.allocationSheetId!=undefined){
    this._allocationSheetsServiceProxy
    .getAllocationSheetForEdit(this.allocationSheetId)
    .subscribe((data) => {
      this.allocationSheetStatus = data.allocationSheet.status;
    });}
  }

  copyActivitybyActivityId() {
    alert(this.selectedforCopyActivityId.activityDay);
    this._activityDaysServiceProxy.copyActivitybyActivityId(this.selectedforCopyActivityId.activityId).subscribe(() => {
      this.closePanel();
            this.onListReload.emit();
            this.notify.success(this.l('ActivityHasBeenRemoved'));
            this.selectedforCopyActivityId=null;

    });
  }
}
